import {LocationDto} from '../dto/location.dto';
import {Location} from '../model/location';

export function convertLocationDtoToModel(dto: LocationDto): Location {
  return {
    ...dto,
    id: dto._id,
  };
}
